import { render, staticRenderFns } from "./CustomDialog.vue?vue&type=template&id=21bbebad&scoped=true"
import script from "./CustomDialog.vue?vue&type=script&lang=js"
export * from "./CustomDialog.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=21bbebad&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbebad",
  null
  
)

export default component.exports